import React, { useEffect, useState } from 'react';
import { FeaturedJobs } from "../FeaturedJobs/FeaturedJobs";
import { RefinedSearch } from "../RefinedSearch/RefinedSearch";
import { withRouter } from "react-router-dom";
import { QuickJobs } from "../QuickJobs/QuickJobs";
import { urlToObject } from "../../helpers/search";
import { JobDetail } from "../JobDetail/JobDetail";
import { useQuery } from "react-query";
import { WidgetMode } from "../../constants";
import getEntries from "../../contentful/getEntries";
import getContentfulMode from "../../contentful/getMode";
import {
  IBusinessAreaFields,
  ICountryFields,
  IJobsSearchFeaturedJobsWidgetFields,
  IJobsSearchJobDetailsFields,
  IJobsSearchJobSearchWidgetFields,
  IJobsSearchQuickJobsWidgetFields
} from "../../@types/contentful";
import { CONTENTFUL_IDS } from "../../contentful/constants";

function App({ location, push, history, ...props }: any) {
  const mode: WidgetMode = process.env.REACT_APP_WIDGET_MODE;
  const contentfulMode = getContentfulMode(mode);
  const { jobId } = urlToObject(location);
  const {
    data,
  } = useQuery([contentfulMode], getEntries, { refetchOnWindowFocus: false });
  const {
    data: contentfulJobCategories,
  } = useQuery([CONTENTFUL_IDS.jobCategories], getEntries, { refetchOnWindowFocus: false });

  const {
    data: contentfulCountries,
  } = useQuery([CONTENTFUL_IDS.countries], getEntries, { refetchOnWindowFocus: false });

  const [contentfulData, setContentfulData] = useState<IJobsSearchJobSearchWidgetFields | IJobsSearchQuickJobsWidgetFields | IJobsSearchFeaturedJobsWidgetFields>();
  const jobCategories: IBusinessAreaFields[] = contentfulJobCategories?.items.map((item: { fields: IBusinessAreaFields }) => item.fields);
  const countryCategories: ICountryFields[] = contentfulCountries?.items.map((item: { fields: ICountryFields }) => item.fields);

  useEffect(() => {
    if (data) {
      setContentfulData(data?.items[0].fields);
    }
  }, [data])

  if (jobId) {
    return (
      <JobDetail
        jobId={jobId as string}
        contentfulJobCategories={jobCategories}
        contentfulData={contentfulData?.jobDetails.fields as IJobsSearchJobDetailsFields}
      />
    );
  }

  const getContent = () => {
    if (mode === 'featured-jobs') {
      return (
        <FeaturedJobs
          contentfulData={contentfulData as IJobsSearchFeaturedJobsWidgetFields}
        />
      );
    }
    if (mode === 'quick-jobs') {
      return (
          <QuickJobs
            contentfulJobCategories={jobCategories}
            contentfulData={contentfulData as IJobsSearchQuickJobsWidgetFields}
          />
      );
    }
    return (
      //mode === jobs-search
      <RefinedSearch
        contentfulJobCategories={jobCategories}
        contentfulData={contentfulData as IJobsSearchJobSearchWidgetFields}
        contentfulCountryList={countryCategories}
      />
    );
  }

  return getContent();
}

export default withRouter(App);
